import { WdkDependencies } from '@veupathdb/wdk-client/lib/Hooks/WdkDependenciesEffect';

export default function wrapWdkDependencies(wdkDependencies: WdkDependencies) {
  return wdkDependencies;
}
